export const CONTEXT_ENUM = {
  client: 'client',
  project: 'project'
};
